<template>
  <v-container id="master-kumpul-bencana" fluid tag="section" class="cyber-container">
    <v-row>
      <v-col cols="12" md="5">
        <base-material-card
          color="#018C74"
          icon="mdi-shield-home"
          class="glass-card full-height"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-title">
              TITIK KUMPUL EVAKUASI
            </div>
            <div class="subtitle-2 secondary-text">
              Manajemen Lokasi Pengungsian & Titik Aman
            </div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  v-model="editedItem.kecamatan_bps"
                  :items="kecamatanOptions"
                  item-text="nama_kecamatan"
                  item-value="kode_bps"
                  label="Otoritas Kecamatan"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-map-marker-radius"
                  class="cyber-input"
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-autocomplete
                  v-model="editedItem.desa_bps"
                  :items="filteredVillageOptions"
                  item-text="desa"
                  item-value="kode_bps"
                  label="Wilayah Desa/Kelurahan"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-home-map-marker"
                  class="cyber-input"
                  :disabled="!editedItem.kecamatan_bps"
                  :placeholder="
                    editedItem.kecamatan_bps
                      ? 'Cari & pilih desa...'
                      : 'Pilih kecamatan dahulu'
                  "
                  no-data-text="Data desa tidak ditemukan"
                  clearable
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title style="color: #018c74; font-size: 14px">{{
                        data.item.desa
                      }}</v-list-item-title>
                      <v-list-item-subtitle style="color: #cfa22d; font-size: 10px">
                        KODE BPS: {{ data.item.kode_bps }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.deskripsi"
                  label="Deskripsi Lokasi / Fasilitas"
                  outlined
                  color="#018C74"
                  rows="3"
                  class="cyber-input"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.koordinat"
                  label="Koordinat Geospasial"
                  outlined
                  color="#CFA22D"
                  prepend-inner-icon="mdi-target-variant"
                  class="cyber-coord-field"
                  readonly
                  hint="Klik pada peta untuk mengambil titik"
                  persistent-hint
                />
              </v-col>
            </v-row>

            <v-card-actions class="px-0 pt-6">
              <v-btn text color="rgba(255,255,255,0.6)" @click="clearForm">RESET</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#CFA22D"
                class="cyber-btn-save"
                :loading="loading"
                @click="save"
              >
                <v-icon left>mdi-map-marker-plus</v-icon> SIMPAN DATA
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="7">
        <base-material-card
          color="#CFA22D"
          icon="mdi-map-search-outline"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black white--text">NAVIGASI LOKASI</div>
          </template>
          <div class="map-wrapper">
            <div id="map-kumpul" class="cyber-map-container"></div>
          </div>
        </base-material-card>
      </v-col>

      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-database-marker"
          class="glass-card mt-6"
        >
          <template v-slot:heading>
            <v-row align="center" dense>
              <v-col cols="12" md="6"
                ><div class="display-1 font-weight-black white--text">
                  ARSIP TITIK KUMPUL
                </div></v-col
              >
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Cari..."
                  single-line
                  hide-details
                  rounded
                  dense
                  color="#CFA22D"
                />
              </v-col>
            </v-row>
          </template>

          <v-data-table
            :headers="headers"
            :items="kumpulList"
            :search="search"
            :loading="loading"
            class="transparent-table"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn icon color="#018C74" @click="editItem(item)"
                ><v-icon small>mdi-lead-pencil</v-icon></v-btn
              >
              <v-btn icon color="#ff5252" @click="deleteItem(item)"
                ><v-icon small>mdi-delete-variant</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    search: "",
    loading: false,
    kumpulList: [],
    kecamatanOptions: [],
    listBps: [],
    map: null,
    marker: null,
    headers: [
      { text: "KECAMATAN (BPS)", value: "kecamatan_bps" },
      { text: "DESA (BPS)", value: "desa_bps" },
      { text: "DESKRIPSI", value: "deskripsi" },
      { text: "KOORDINAT", value: "koordinat" },
      { text: "AKSI", value: "actions", align: "end", sortable: false },
    ],
    editedItem: {
      id: null,
      desa_bps: null,
      kecamatan_bps: null,
      deskripsi: "",
      koordinat: "",
    },
    defaultItem: {
      id: null,
      desa_bps: null,
      kecamatan_bps: null,
      deskripsi: "",
      koordinat: "",
    },
  }),

  computed: {
    filteredVillageOptions() {
      if (!this.editedItem.kecamatan_bps || this.kecamatanOptions.length === 0) return [];

      const selectedKecObj = this.kecamatanOptions.find(
        (k) => k.kode_bps == this.editedItem.kecamatan_bps
      );
      if (!selectedKecObj) return [];

      const targetName = selectedKecObj.nama_kecamatan.trim().toUpperCase();

      return this.listBps.filter((item) => {
        const bpsKecName = (item.nama_kecamatan || "").trim().toUpperCase();
        return bpsKecName === targetName;
      });
    },
  },

  watch: {
    "editedItem.kecamatan_bps"() {
      if (!this.editedItem.id) {
        this.editedItem.desa_bps = null;
      }
    },
  },

  mounted() {
    this.fetchData();
    this.fetchKecamatan();
    this.fetchMasterData();
    this.initMap();
  },

  methods: {
    async fetchMasterData() {
      try {
        const response = await axios.get(`${BASE_URL}/api/android/master-init`, {
          headers: {
            "Bondowoso-Berkah":
              "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97",
          },
        });
        this.listBps = response.data.response.data.data.bps || [];
      } catch (e) {
        console.error("Gagal Muat Master BPS", e);
      }
    },

    async fetchKecamatan() {
      try {
        const res = await axios.get(`${BASE_URL}/kecamatan`);
        if (res.data?.response?.data) {
          this.kecamatanOptions = res.data.response.data;
        }
      } catch (e) {
        console.error("Error Fetch Kecamatan", e);
      }
    },

    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/master/kumpul-bencana`);
        this.kumpulList = res.data?.response?.data || [];
      } catch (e) {
        this.kumpulList = [];
      } finally {
        this.loading = false;
      }
    },

    initMap() {
      setTimeout(() => {
        this.map = L.map("map-kumpul", { zoomControl: false }).setView(
          [-7.9135, 113.8215],
          12
        );
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map);
        this.map.on("click", (e) => {
          const { lat, lng } = e.latlng;
          this.editedItem.koordinat = `${lat.toFixed(6)},${lng.toFixed(6)}`;
          this.updateMarker(lat, lng);
        });
      }, 500);
    },

    updateMarker(lat, lng) {
      if (this.marker) this.map.removeLayer(this.marker);
      this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.koordinat) {
        const [lat, lng] = this.editedItem.koordinat.split(",").map(Number);
        if (!isNaN(lat)) {
          this.updateMarker(lat, lng);
          this.map.setView([lat, lng], 15);
        }
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async save() {
      if (!this.editedItem.kecamatan_bps || !this.editedItem.desa_bps)
        return alert("Pilih Wilayah Lengkap!");
      this.loading = true;
      try {
        if (this.editedItem.id) {
          await axios.put(
            `${BASE_URL}/master/kumpul-bencana/${this.editedItem.id}`,
            this.editedItem
          );
        } else {
          await axios.post(`${BASE_URL}/master/kumpul-bencana`, this.editedItem);
        }
        this.fetchData();
        this.clearForm();
      } catch (e) {
        alert("Error saving data");
      } finally {
        this.loading = false;
      }
    },

    clearForm() {
      this.editedItem = Object.assign({}, this.defaultItem);
      if (this.marker) this.map.removeLayer(this.marker);
    },

    async deleteItem(item) {
      if (confirm("Hapus data?")) {
        await axios.delete(`${BASE_URL}/master/kumpul-bencana/${item.id}`);
        this.fetchData();
      }
    },
  },
};
</script>

<style scoped>
.cyber-container {
  background: transparent;
}
.cyber-title {
  letter-spacing: 2px !important;
  color: white !important;
  text-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}
.secondary-text {
  color: #cfa22d !important;
}
.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.transparent-table {
  background: transparent !important;
}
.transparent-table >>> th {
  color: #cfa22d !important;
  border-bottom: 2px solid #018c74 !important;
}
.cyber-btn-save {
  background-color: #cfa22d !important;
  color: #002616 !important;
  font-weight: 900 !important;
}
.cyber-map-container {
  height: 450px;
  width: 100%;
  border-radius: 4px;
}
.map-wrapper {
  padding: 8px;
  border: 1px solid #cfa22d;
  background: rgba(0, 0, 0, 0.2);
}
.cyber-coord-field >>> input {
  color: #cfa22d !important;
  font-family: monospace;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
